export default {
  documentTitle: 'KeyPal，您的数字资产硬件钱包，保护您的资产安全',
  product: '产品',
  learn: '学习',
  support: '支持',
  others: '其他',
  language: '语言',
}
